<template>
  <div class="moduleStyle minHeight">
    <div class="tabs">
      <ul>
        <li
          :class="activeId == item.val ? 'tabs_active' : ''"
          @click="changeTabs(item.val)"
          v-for="item in tabslist"
          :key="item.val"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
    <div class="table" v-if="activeId == 1">
    <basicList
      :config="basicListconfig"
      @sortChange="sortChange"
      @search="searchEvent"
    >
      <!-- <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
        </div>
      </template> -->
      <template v-slot:status="row">
        <div style="display: flex; align-items: center">
          <div
            v-if="row.row.status=='正常'"
          >
            {{ row.row.status }}
          </div>
          <div v-else class="redcolor">{{ row.row.status }}</div>
        </div>
      </template>
    </basicList>
    </div>
    <div class="table" v-if="activeId == 2">
      <basicList
        :config="basicListconfiguser"
        @sortChange="sortChangeuser"
        @search="searchEventuser"
      >
        <template v-slot:otherOperations>
          <el-button size="small" type="primary" @click="handleExportAttendanceUser">导出考勤</el-button>
        </template>
        <!-- <template v-slot:operation="row">
          <div style="display: flex; align-items: center">
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </div>
        </template> -->
        <template v-slot:status="row">
          <div style="display: flex; align-items: center">
            <div
              v-if="row.row.status=='正常'"
            >
              {{ row.row.status }}
            </div>
            <div v-else class="redcolor">{{ row.row.status }}</div>
          </div>
        </template>
      </basicList>
    </div>
  </div>
</template>


<script>
// 列表默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
import { userGetlist, getshoplist,attendanceList,attendanceListuser } from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "salesAnalysis",
  data() {
    return {
      activeId: 1,
      tabslist: [
        {
          label: "营业记录",
          val: 1,
        },
        {
          label: "员工考勤",
          val: 2,
        },
      ],
      // 列表组件参数
      basicListconfig: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "指定员工",
            type: "select",
            options: [],
            key: "user_id",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        column: [
          {
            label: "日期",
            prop: "attendance_time",
            width: 120,
            fixed:"left"
          },
          {
            label: "门店",
            prop: "shopname",
            width: 120,
          },
          {
            label: "值班人员",
            prop: "username",
            width: 250,
          },
          {
            label: "开门时间",
            prop: "starttime",
            width: 120,
          },
          {
            label: "关门时间",
            prop: "endtime",
            width: 120,
          },
          {
            label: "类型",
            prop: "status",
            slot: true,
            width: 120,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      basicListconfiguser: {
        loading: false,
        operation: false,
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "指定员工",
            type: "select",
            options: [],
            key: "user_id",
          },
          {
            label: "日期",
            type: "quickDate",
            key: "time",
          },
        ],
        data: [],
        column: [
          {
            label: "日期",
            prop: "attendance_time",
            width: 120,
            fixed:"left"
          },
          {
            label: "门店",
            prop: "shopname",
            width: 120,
          },
          {
            label: "员工姓名",
            prop: "user_name",
            width: 250,
          },
          {
            label: "上班时间",
            prop: "starttime",
            width: 120,
          },
          {
            label: "下班时间",
            prop: "endtime",
            width: 120,
          },
          {
            label: "类型",
            prop: "status",
            slot: true,
            width: 120,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.getData();
    this.obtainDataSource();
    this.searchEvent({
      shop_id: JSON.parse(getRoles()).shop_id,
    });
    this.searchEventuser({
      shop_id: JSON.parse(getRoles()).shop_id,
    });

  },
  methods: {
    changeTabs(id) {
      this.activeId = id;
      if (id == 1) {
        this.getData();
        // 在这一页，把其他两页的残留数据清理掉
        this.dailyDiskLibraryListconfig.data = [];
        this.overdueListconfig.data = [];
      } else if (id == 2) {
        this.getDatauser();
      }
    },
    // 排序方法
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getData();
    },
    // 搜索方法
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getData();
      } else if (data) {
        for (const key in data) {
         for (const key in data) {
           this.basicListconfig.searchParameters[key] = data[key];
           if (key == "time") {
             this.basicListconfig.searchParameters["begin_time"] = data[key]
               ? data[key][0]
               : null;
             this.basicListconfig.searchParameters["end_time"] = data[key]
               ? data[key][1]
               : null;
           }
         }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getData();
      }
    },
    getData() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfig.loading = true;
      attendanceList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.total = Number(res.count);
          this.basicListconfig.data = res.list.map((item) => {
            return item;
          });
        } else {
          this.basicListconfig.loading = fals;
          this.$message.error(res.msg);
        }
      });
    },
    sortChangeuser(data) {
      this.basicListconfiguser.searchParameters.page = 1;
      this.basicListconfiguser.searchParameters.order_column = data.prop;
      this.basicListconfiguser.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getDatauser();
    },
    // 搜索方法
    searchEventuser(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfiguser.page = page;
        if (pageSize) this.basicListconfiguser.searchParameters.limit = pageSize;
        this.getDatauser();
      } else if (data) {
        for (const key in data) {
         for (const key in data) {
           this.basicListconfiguser.searchParameters[key] = data[key];
           if (key == "time") {
             this.basicListconfiguser.searchParameters["begin_time"] = data[key]
               ? data[key][0]
               : null;
             this.basicListconfiguser.searchParameters["end_time"] = data[key]
               ? data[key][1]
               : null;
           }
         }
          this.basicListconfiguser.searchParameters[key] = data[key];
        }
        this.basicListconfiguser.searchParameters.page = 1;
        this.getDatauser();
      }
    },
    getDatauser() {
      this.basicListconfiguser.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfiguser.searchParameters["shop_id"];
        }
        return item;
      });
      this.basicListconfiguser.loading = true;
      attendanceListuser(this.basicListconfiguser.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfiguser.loading = false;
          this.basicListconfiguser.total = Number(res.count);
          this.basicListconfiguser.data = res.list.map((item) => {
            return item;
          });
        } else {
          this.basicListconfiguser.loading = fals;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
     userGetlist({ limit: 10000, status: 0 }).then((res) => {
       if (res.code == 1) {
         this.basicListconfig.search.map((item) => {
           if (item.key == "user_id") {
             item.options = res.data.map((item) => {
               return {
                 label: item.name,
                 value: item.id,
               };
             });
           }
           return item;

         });
         this.basicListconfiguser.search.map((item) => {
           if (item.key == "user_id") {
             item.options = res.data.map((item) => {
               return {
                 label: item.name,
                 value: item.id,
               };
             });
           }
           return item;

         });
       } else {
         this.$message.error(res.data.msg || "获取供应商数据源失败！");
       }
     });
      getshoplist({ status: 0, comp_id: JSON.parse(getRoles()).comp_id }).then(
        (res) => {
          if (res.code == 1) {
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
            this.basicListconfiguser.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: item.id,
                  };
                });
              }
              return item;
            });
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 导出考勤
    handleExportAttendance() {
      const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'http://uaterp.zuizhenshi.cn';
      const params = new URLSearchParams();
      params.append('comp_id', JSON.parse(getRoles()).comp_id);
      
      // 添加搜索参数
      const searchParams = this.basicListconfig.searchParameters;
      if (searchParams.shop_id) params.append('shop_id', searchParams.shop_id);
      if (searchParams.user_id) params.append('user_id', searchParams.user_id);
      if (searchParams.begin_time) params.append('begin_time', searchParams.begin_time);
      if (searchParams.end_time) params.append('end_time', searchParams.end_time);
      
      const url = `${apiBase}/admin/Attendance/export_excel?${params.toString()}`;
      window.open(url, '_blank');
    },
    // 导出员工考勤
    handleExportAttendanceUser() {
      const apiBase = process.env.VUE_APP_BASE_API ? process.env.VUE_APP_BASE_API.replace(/"/g, '') : 'http://uaterp.zuizhenshi.cn';
      const params = new URLSearchParams();
      params.append('comp_id', JSON.parse(getRoles()).comp_id);
      
      // 添加搜索参数
      const searchParams = this.basicListconfiguser.searchParameters;
      if (searchParams.shop_id) params.append('shop_id', searchParams.shop_id);
      if (searchParams.user_id) params.append('user_id', searchParams.user_id);
      
      // 处理时间参数 - 优先使用 begin_time/end_time，如果没有则尝试从 time 获取
      let beginTime = searchParams.begin_time;
      let endTime = searchParams.end_time;
      
      // 如果没有 begin_time/end_time，但有 time 数组，则从 time 获取
      if (!beginTime && searchParams.time && Array.isArray(searchParams.time) && searchParams.time.length === 2) {
        beginTime = searchParams.time[0];
        endTime = searchParams.time[1];
      }
      
      if (beginTime) params.append('begin_time', beginTime);
      if (endTime) params.append('end_time', endTime);
      
      const url = `${apiBase}/admin/Attendance/export_excel_user?${params.toString()}`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style>
  .redcolor {
    color: red; /* 红色文字 */
  }
</style>



// WEBPACK FOOTER //
// src/views/attendanceAnalysis/index.vue